const stickyHeadline = document.getElementById("stickyHeadline");
let headlines = document.getElementsByClassName("list-headline");
const searchHeader = document.getElementById("searchHeader");

const stickyOffset = -80;

window.addEventListener("scroll", () => {
    if (!searchHeader) return;

    if (window.scrollY - stickyOffset < searchHeader.offsetHeight) {
        stickyHeadline.textContent = "";
    }
    for (const headline of headlines) {
        if (window.scrollY + searchHeader.offsetHeight - stickyOffset > headline.offsetTop) {
            if (stickyHeadline.textContent != headline.textContent) {
                stickyHeadline.textContent = headline.textContent;
            }
        }
    }
});

document.addEventListener("alpine:init", () => {
    Alpine.data("analysisSearch", (action, columns) => ({
        selectedColumns: window.matchMedia("(max-width: 1024px)").matches
            ? ["id", "name"]
            : ["id", "name", "duration", "material", "index"],
        searchArea: "",
        open: false,
        isMobile: window.matchMedia("(max-width: 1024px)"),
        columns: [],
        action: "/",
        page: 1,
        perPage: 20,
        searchInput: "",
        sortBy: "name",
        sortDirection: "asc",
        isLoading: true,
        results: [],
        groupedResults: [],
        init() {
            this.action = action;
            this.columns = Object.values(JSON.parse(columns));

            const searchParam = new URLSearchParams(window.location.search).get("search");

            if (searchParam) {
                this.searchInput = searchParam;
                this.lastSearch = searchParam.trim();
                this.sortBy = "";
            }

            this.isMobile.addEventListener("change", (event) => {
                if (event.matches) {
                    this.selectedColumns = ["id", "name"];
                } else {
                    this.selectedColumns = ["id", "name", "duration", "material", "index"];
                }
            });

            this.$refs.searchList.dataset.columns = this.selectedColumns.toString();

            this.$watch("searchInput", () => {
                const url = new URL(location);
                const input = this.searchInput.trim();
                if (input) {
                    url.searchParams.set("search", input);
                    this.sortBy = "";
                } else {
                    url.searchParams.delete("search");
                    this.sortBy = "name";
                }
                this.sortDirection = "asc";
                this.page = 1;
                this.search();
                history.pushState({}, "", url);
            });
            this.$watch("page", () => {
                this.search(true);
            });
            this.$watch("selectedColumns", (value) => {
                this.$refs.searchList.dataset.columns = value.toString();
            });
            this.$watch("searchArea", (value) => {
                const option = document.querySelector(`option[value="${value}"]`);
                window.location.href =
                    option.dataset.uri + (this.searchInput.length ? `?search=${this.searchInput}` : "");
            });

            // Run initial search without parameters to get all results
            this.search();
        },
        search(append = false) {
            this.isLoading = true;
            if (!append) {
                this.groupedResults = [];
            }
            const searchUrl = new URL(window.location.origin + this.action);
            searchUrl.search = new URLSearchParams([
                ["term", this.searchInput === "" ? "_all" : this.searchInput],
                ["page", this.page],
                ["perPage", this.perPage],
                ["sortBy", this.sortBy],
                ["sortDirection", this.sortDirection],
            ]).toString();

            fetch(searchUrl)
                .then((data) => data.json())
                .then(({ count, hits }) => {
                    this.maxPage = Math.ceil(count / this.perPage);

                    if (append) {
                        this.results = this.results.concat(hits);
                    } else {
                        this.results = hits;
                    }
                    this.groupedResults = [];

                    this.results.forEach((result) => {
                        let start = "";
                        const firstLetter = result.name.slice(0, 1).toUpperCase();
                        if (this.sortBy === "name" && this.searchInput === "") {
                            if (!Number.isNaN(Number(firstLetter))) {
                                start = "#";
                            } else {
                                start = firstLetter
                                    .toLowerCase()
                                    .replaceAll("α", "a")
                                    .replaceAll("β", "b")
                                    .replaceAll("δ", "d")
                                    .replaceAll("γ", "g")
                                    .replaceAll("Ä", "A")
                                    .replaceAll("ä", "a")
                                    .replaceAll("Ö", "O")
                                    .replaceAll("ö", "o")
                                    .replaceAll("Ü", "U")
                                    .replaceAll("ü", "u")
                                    .toUpperCase();
                            }
                        }
                        let resultGroup = this.groupedResults.find((group) => group.start === start);
                        if (resultGroup === undefined) {
                            resultGroup = {
                                start: start,
                                results: [],
                            };
                            this.groupedResults.push(resultGroup);
                        }
                        resultGroup.results.push(result);
                    });
                    if (this.searchInput !== "") {
                        trackingPush({
                            event: "analysis_search",
                            search_term: this.searchInput,
                            search_results: count,
                        });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        renderColumnValue(field, item) {
            if (field === "id") {
                if (item.groupProfile) {
                    return (
                        '<svg width="24" height="24" class="book-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n' +
                        '  <g fill="currentColor">\n' +
                        '    <path d="M22.5,0c-4.669,0 -9.47,1.021 -11,2.786c-1.53,-1.765 -6.331,-2.786 -11,-2.786c-0.276,0 -0.5,0.224 -0.5,0.5v16.5c0,0.276 0.224,0.5 0.5,0.5c5.913,0 10.5,1.613 10.5,3c0,0.276 0.224,0.5 0.5,0.5c0.276,0 0.5,-0.224 0.5,-0.5c0,-1.387 4.587,-3 10.5,-3c0.276,0 0.5,-0.224 0.5,-0.5v-16.5c0,-0.276 -0.224,-0.5 -0.5,-0.5Zm-21.5,16.504v-15.5c5.67,0.087 10,1.648 10,2.996v14.829c-1.829,-1.424 -5.915,-2.262 -10,-2.325Zm21,0c-4.085,0.063 -8.171,0.901 -10,2.325v-14.829c0,-1.348 4.33,-2.909 10,-2.996v15.5Z" transform="translate(0, 1)"></path>\n' +
                        '    <path d="M7.197,1.277c-1.683,-0.644 -4.042,-1.096 -6.645,-1.272c-0.261,-0.005 -0.514,0.189 -0.533,0.465c-0.019,0.276 0.189,0.514 0.465,0.533c2.507,0.169 4.764,0.599 6.355,1.208c0.059,0.022 0.119,0.033 0.179,0.033c0.201,0 0.391,-0.122 0.467,-0.321c0.098,-0.258 -0.03,-0.547 -0.288,-0.646Z" transform="translate(1.982, 5.496)"></path>\n' +
                        '    <path d="M7.197,1.28c-1.683,-0.644 -4.042,-1.096 -6.645,-1.272c-0.261,-0.008 -0.514,0.189 -0.533,0.465c-0.019,0.276 0.189,0.514 0.465,0.533c2.507,0.169 4.764,0.599 6.355,1.208c0.059,0.022 0.119,0.033 0.179,0.033c0.201,0 0.391,-0.122 0.467,-0.321c0.098,-0.258 -0.03,-0.547 -0.288,-0.646Z" transform="translate(1.982, 8.493)"></path>\n' +
                        '    <path d="M7.197,1.283c-1.683,-0.645 -4.042,-1.096 -6.645,-1.272c-0.261,-0.011 -0.514,0.189 -0.533,0.465c-0.019,0.275 0.189,0.514 0.465,0.533c2.507,0.169 4.764,0.599 6.355,1.208c0.059,0.022 0.119,0.033 0.179,0.033c0.201,0 0.391,-0.122 0.467,-0.321c0.098,-0.258 -0.03,-0.547 -0.288,-0.646Z" transform="translate(1.982, 11.49)"></path>\n' +
                        '    <path d="M7.197,1.286c-1.683,-0.645 -4.042,-1.096 -6.645,-1.272c-0.261,-0.014 -0.515,0.189 -0.533,0.465c-0.019,0.275 0.189,0.514 0.465,0.533c2.507,0.169 4.764,0.599 6.355,1.208c0.059,0.022 0.119,0.033 0.179,0.033c0.201,0 0.391,-0.122 0.467,-0.321c0.098,-0.258 -0.03,-0.547 -0.288,-0.646Z" transform="translate(1.982, 14.487)"></path>\n' +
                        '    <path d="M0.566,2.244c0.06,0 0.12,-0.011 0.179,-0.033c1.592,-0.609 3.849,-1.039 6.355,-1.208c0.275,-0.019 0.483,-0.257 0.465,-0.533c-0.019,-0.276 -0.265,-0.47 -0.533,-0.465c-2.603,0.176 -4.962,0.628 -6.645,1.272c-0.258,0.099 -0.387,0.388 -0.288,0.646c0.076,0.199 0.266,0.321 0.467,0.321Z" transform="translate(13.434, 5.496)"></path>\n' +
                        '    <path d="M0.566,2.247c0.06,0 0.12,-0.011 0.179,-0.033c1.592,-0.609 3.849,-1.039 6.355,-1.208c0.275,-0.019 0.483,-0.257 0.465,-0.533c-0.019,-0.276 -0.265,-0.473 -0.533,-0.465c-2.603,0.176 -4.962,0.628 -6.645,1.272c-0.258,0.099 -0.387,0.388 -0.288,0.646c0.076,0.199 0.266,0.321 0.467,0.321Z" transform="translate(13.434, 8.493)"></path>\n' +
                        '    <path d="M0.566,2.25c0.06,0 0.12,-0.011 0.179,-0.033c1.592,-0.609 3.849,-1.039 6.355,-1.208c0.275,-0.019 0.483,-0.257 0.465,-0.533c-0.019,-0.276 -0.265,-0.476 -0.533,-0.465c-2.603,0.176 -4.962,0.628 -6.645,1.272c-0.258,0.099 -0.387,0.388 -0.288,0.646c0.076,0.199 0.266,0.321 0.467,0.321Z" transform="translate(13.434, 11.49)"></path>\n' +
                        '    <path d="M0.566,2.253c0.06,0 0.12,-0.011 0.179,-0.033c1.592,-0.609 3.849,-1.039 6.355,-1.208c0.275,-0.019 0.483,-0.257 0.465,-0.533c-0.019,-0.276 -0.265,-0.479 -0.533,-0.465c-2.603,0.176 -4.962,0.628 -6.645,1.272c-0.258,0.099 -0.387,0.388 -0.288,0.646c0.076,0.199 0.266,0.321 0.467,0.321Z" transform="translate(13.434, 14.487)"></path>\n' +
                        "  </g>\n" +
                        "</svg>"
                    );
                } else {
                    return item.id;
                }
            }
            if (field === "price") {
                // Add static strings and linebreaks for
                // item.pricePositive (cost if test comes back positive),
                // item.priceNegative (cost if test comes back negative)
                // and item.price (default price)
                return [
                    item.pricePositive
                        ? `${this.$refs.searchList.dataset.resultPositiveText}: ${this.$refs.searchList.dataset.resultCurrency} ${item.pricePositive}`
                        : null,
                    item.priceNegative
                        ? `${this.$refs.searchList.dataset.resultNegativeText}: ${this.$refs.searchList.dataset.resultCurrency} ${item.priceNegative}`
                        : null,
                    item.price && !item.pricePositive && !item.priceNegative
                        ? `${this.$refs.searchList.dataset.resultCurrency} ${item.price}`
                        : null,
                ]
                    .filter((n) => n)
                    .join("<br/>");
            }
            return item[field];
        },
        showCol(id) {
            return this.selectedColumns.includes(id);
        },
        setSortBy($event) {
            if (this.sortBy === $event.target.dataset.id) {
                this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
            } else {
                this.sortBy = $event.target.dataset.id;
                this.sortDirection = "asc";
            }
            this.page = 1;
            this.search();
        },
        checkPage() {
            if (this.maxPage === this.page) {
                return;
            }
            let documentHeight = document.body.scrollHeight;
            let currentScroll = window.scrollY + window.innerHeight;
            let modifier = Math.max(window.innerHeight * 2, 2000);
            if (currentScroll + modifier > documentHeight) {
                this.page = this.page + 1;
            }
        },
        trackClick(event) {
            const link = event.target.closest("a");

            // Search analytics click
            trackingPush({
                event: "analysis_search_click",
                search_term: this.searchInput,
                search_result_clicked: link.getAttribute("name"),
            });
        },
    }));
    Alpine.data("websiteSearch", (action) => ({
        action: "/",
        selectedColumns: ["title", "text", "type"],
        searchArea: "",
        searchInput: "",
        sortedBy: "",
        sortAsc: true,
        sortOrder: [],
        open: false,
        loading: false,
        isMobile: false,
        results: [],
        resultsBackup: "",
        resultsFound: null,
        parsedResults: [],
        setAction(action) {
            this.action = action;
        },
        async init() {
            if (window.innerWidth < 1024) {
                this.isMobile = true;
                this.selectedColumns = ["title", "text"];
            }
            this.resultsBackup = this.$refs.searchList.innerHTML;

            this.setAction(action);

            const searchParam = new URLSearchParams(window.location.search).get("search");
            if (searchParam) {
                this.searchInput = searchParam;
                this.getResults();
            }

            this.$watch("searchArea", (value) => {
                const option = document.querySelector(`option[value="${value}"]`);
                window.location.href =
                    option.dataset.uri + (this.searchInput.length ? `?search=${this.searchInput}` : "");
            });
        },
        onResize() {
            if (window.innerWidth < 1024 && !this.isMobile) {
                this.selectedColumns = ["title", "text"];
                this.isMobile = true;
            } else if (window.innerWidth > 1024 && this.isMobile) {
                this.selectedColumns = ["title", "text", "type"];
                this.isMobile = false;
            }
        },
        showCol(id) {
            return this.selectedColumns.includes(id);
        },
        sortBy(sortColumnId) {
            if (this.sortedBy === sortColumnId) {
                this.sortAsc = !this.sortAsc;
            } else {
                this.sortedBy = sortColumnId;
                this.sortAsc = true;
            }

            this.results = this.results.sort((a, b) => {
                if (a[this.sortedBy] < b[this.sortedBy]) return this.sortAsc ? -1 : 1;
                if (a[this.sortedBy] > b[this.sortedBy]) return this.sortAsc ? 1 : -1;
                return 0;
            });
        },
        resetResults() {
            this.searchInput = "";
            this.results = [];
            this.sortedBy = "";
        },
        async getResults() {
            if (this.searchInput === "") {
                this.resetResults();
            } else {
                const searchInput = this.searchInput;
                this.loading = true;
                const fetchedResults = await this.fetchResults(searchInput);
                this.results = fetchedResults.results || [];
                this.resultsFound = this.results.length;
                this.loading = false;

                const url = new URL(location);
                url.searchParams.set("search", searchInput);
                history.pushState({}, "", url);

                // Search website
                window.trackingPush({
                    event: "general_search",
                    search_term: this.searchInput,
                    search_results: this.results.length,
                });
            }
        },
        async fetchResults(input) {
            const result = await fetch(this.action + encodeURIComponent(input));
            return await result.json();
        },
        synchronizeScrollsByColumns() {
            this.$refs.searchResults.scrollLeft = this.$refs.searchColumns.scrollLeft || 0;
        },
        synchronizeScrollsByResults() {
            this.$refs.searchColumns.scrollLeft = this.$refs.searchResults.scrollLeft || 0;
        },
        trackClick(event) {
            // event.preventDefault();
            const link = event.target.closest("a");

            // Search website click
            trackingPush({
                event: "general_search_click",
                search_term: this.searchInput,
                search_result_clicked: link.getAttribute("name"),
            });
        },
    }));
});
